import React, { useState } from "react"

function ProjectsInfo(props) { 
    const [imageLoaded, setImageLoaded] = useState(false)
    let element = <a href={props.git} target="_blank" rel="noreferrer" className="btn">Github</a>

    const handleCardHover = (event) => {
        const bounds = event.currentTarget.getBoundingClientRect()
        const x = event.clientX - bounds.left
        const y = event.clientY - bounds.top

        event.currentTarget.style.setProperty("--hover-x", `${x}px`)
        event.currentTarget.style.setProperty("--hover-y", `${y}px`)
    }

    return (
        <section className="projects_content-info" onMouseMove={handleCardHover}>
            <section className="content">
                <a
                    href={props.link}
                    target="_blank"
                    rel="noreferrer"
                    className="image-link"
                >
                    <img
                        src={`../../assets/images/projects/${props.image}`}
                        alt={props.title}
                        className={imageLoaded ? "fade-in loaded" : "fade-in"}
                        onLoad={() => setImageLoaded(true)}
                    />
                </a>
                <div className="info"> 
                    <h3>{props.title}</h3>
                    <p>{props.desc}</p>
                    
                    
                    <div className="btn">
                        <a href={props.link} target="_blank" rel="noreferrer" className="btn-link">Preview</a>
                        {props.git && element}
                    </div>
                </div>
            </section>
        </section>
    )
}

export default ProjectsInfo
